import * as React from "react";
const SvgFiRrDrumstick = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-drumstick_svg__a)">
      <path
        fill="#062147"
        d="M21.5 2.5a8.58 8.58 0 0 0-12.075 0c-2.377 2.377-3.157 7.91-3.41 11-.07.869.135 1.737.585 2.483l-3.8 3.8a1.5 1.5 0 1 0-.65 2.063 1.5 1.5 0 1 0 2.064-.649l3.8-3.8a4.14 4.14 0 0 0 2.484.592c3.086-.253 8.617-1.032 11-3.41A8.577 8.577 0 0 0 21.5 2.5m-1.415 10.662c-1.387 1.385-5.03 2.444-9.744 2.831a2.155 2.155 0 0 1-2.334-2.334c.387-4.715 1.446-8.359 2.83-9.744A6.538 6.538 0 0 1 22.05 8.524a6.54 6.54 0 0 1-1.965 4.638"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-drumstick_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrDrumstick;
